// import "./wdyr"

import * as React from 'react'

import { I18nextProvider } from 'react-i18next'

import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { RecoilRoot } from 'recoil'
import { useOperationMethod } from './Components/OpenApi/useOperationMethod'
import { useUList } from './Components/OpenApi/useUList'
import AppRoutes from './Components/AppRoutes'
import { useULogin } from './Components/UseULogin';
import AppLoginRoutes from './Components/AppLoginRoutes'
import AppUserRoutes from './Components/AppUserRoutes';
import { useUSave } from './Components/OpenApi/useUSave';
import { useURemove } from './Components/OpenApi/useURemove'
import { useURequest } from './Components/OpenApi/useURequest';
import { naeUserState } from './state/NaeUserState'
import { useSetUserState } from './Components/UseSetUserStatte'

interface Props {
  i18n?: any
  children: any
}

export const NaeAuthWrapper = ({ i18n, children }: Props) => {
  return (
    <React.Fragment>
      {!!i18n ? (
        <I18nextProvider i18n={i18n}>
          <RecoilRoot>{children}</RecoilRoot>
        </I18nextProvider>
      ) : (
        <RecoilRoot>{children}</RecoilRoot>
      )}

      <ToastContainer
        position={'bottom-right'}
        hideProgressBar
        newestOnTop={false}
      />
    </React.Fragment>
  )
}

export const OpenApi = {
  // useOperation: useOperation,
  useOperationMethod: useOperationMethod,
  useUList: useUList,
  useUSave: useUSave,
  useURemove: useURemove,
  useURequest: useURequest,

  naeUserState: naeUserState,

  toast: {
    success: (text: string) => {
      toast.success(text);
    },
    error: (text: string) => {
      toast.error(text);
    }
  },

  naePaths: {}
}

export const Components = {
  AppRoutes: AppRoutes,
  AppLoginRoutes: AppLoginRoutes,
  AppUserRoutes: AppUserRoutes,
}

export const Hooks = {
  useULogin: useULogin,
  useSetUserState: useSetUserState,
}